import { getDocumentById } from '@/lib/functions/apiCalls';
import { FindDocuments, UploadDocumentResponse } from '@/lib/types/apiTypes';
import { FC } from 'react';
import LoadingLogo from '@/assets/lotties/logo_loading_v1.json';
import Lottie from 'lottie-react';
import { columns } from '@/components/Tables/DocumentListTable/column';
import { DocumentListTable } from '../Tables/DocumentListTable/DocumentListTable';
import AiIcon from '../ui/icons/AiIcon';

interface MessagesListProps {
	list: FindDocuments[];
	isMessageLoading: boolean;
	setDocLoading: (loading: boolean) => void;
	setDocData: (docData: UploadDocumentResponse | null) => void;
	isSuggestedList?: boolean;
}

const MessagesList: FC<MessagesListProps> = ({
	list,
	isMessageLoading,
	setDocLoading,
	setDocData,
	isSuggestedList = false,
}) => {
	const handleDocument = async (documentId: number) => {
		if (!documentId) return;
		setDocLoading(true);
		const response = await getDocumentById(documentId);
		if (response.statusCode === 200) {
			const docResponse = response.data as UploadDocumentResponse;
			setDocData(docResponse);
			setDocLoading(false);
		}
	};

	const formatFormativeDocumentsData = (list) => {
		return !list
			? []
			: list.map((item) => {
					return {
						documentId: item.documentId,
						name: item.name ?? item.content,
						category: item.category,
					};
				});
	};

	const formativeDocumentsData: any = formatFormativeDocumentsData(list);

	return (
		<div className="h-full pr-2 overflow-y-auto">
			{isMessageLoading ? (
				<div className="flex flex-col items-center justify-center h-full">
					<Lottie
						className="block animation-lottie max-h-24 max-w-24"
						animationData={LoadingLogo}
						loop={true}
						autoPlay={true}
					/>
				</div>
			) : !list ? (
				<div className="flex flex-col justify-center h-full">
					<div className="relative flex px-8 font-medium text-center text-black bg-white">
						You also can try to describe your document and I will try to locate
						it if its in my database
					</div>
				</div>
			) : list.length === 0 ? (
				<div className="flex flex-col justify-center h-full">
					<div className="relative flex px-8 font-medium text-center text-black bg-white rounded-xl">
						You description didn't match any document and please try again with
						different description
					</div>
				</div>
			) : (
				<>
					{isSuggestedList && (
						<div className="flex gap-2.5 items-center justify-start w-full font-bold text-secondary pb-3 border-[#C6DBFB] border-b dynamic-text">
							<AiIcon className="w-5 h-5" fill="#E861C9" /> I found some
							documents that you might find relevant.
						</div>
					)}
					<DocumentListTable
						columns={columns}
						data={formativeDocumentsData}
						handleDocument={handleDocument}
					/>
				</>
			)}
		</div>
	);
};

export default MessagesList;
